import { PrivacyPolicyPage } from '../../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiPrivacyPolicy = (strapiData: any): PrivacyPolicyPage => strapiData.attributes

export {
    fromStrapiPrivacyPolicy,
}